import { GuestInboxSend } from '../../StayTimeline.types'

interface FindAutomatedSendParams {
  eventId: string
  sends: GuestInboxSend[]
}

export const findAutomatedSend = ({ eventId, sends }: FindAutomatedSendParams) => {
  const [, sendId] = eventId.split(':')
  if (!sendId) return undefined

  return sends.find(send => send.id === sendId)
}
